import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		edit: {
			config: {
				fields: {
					employee: {},
					status: {},
					organization: {},
					department: {},
					post: {},
					ward: {},
					created_at: {}
				}
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			config: {
				fields: {
					employee: {},
					status: {},
					department: {},
					post: {},
					ward: {},
					created_at: {}
				}
			},
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		}
	}
}